import type { Middleware } from '@reduxjs/toolkit';

import { logger } from '@/components/SgwtBootstrap/logger.ts';

export const loggerMiddleware: Middleware = () => (next) => (action) => {
  if (!import.meta.env.DEV) {
    return next(action);
  }

  const actionType =
    typeof (action as { type?: string })?.type === 'string'
      ? (action as { type?: string }).type
      : '(unknown action type)';

  const result = next(action);

  if (
    !EXCLUDE_ACTIONS.has(actionType ?? '') &&
    !EXCLUDE_ACTION_PREFIXES.some((prefix) => actionType?.startsWith(prefix))
  ) {
    logger.logInformation(`[ACTION] ${actionType}`, JSON.stringify(action));
  }

  return result;
};

const EXCLUDE_ACTIONS = new Set(['esp/espPriceReceived']);
const EXCLUDE_ACTION_PREFIXES = ['webapi/', '__rtkq/'];